import React from "react";
import { Breadcrumb, Col, Row } from "react-bootstrap";
import UseViewProductDetails from "../../CustomHooks/Products/UseViewProductDetails";
import UseAddProductToCart from "../../CustomHooks/Cart/UseAddProductToCart";
import { AiFillStar, AiOutlineStar } from "react-icons/ai";
import { BsStarHalf } from "react-icons/bs";
import ReactStars from "react-rating-stars-component";


const ProductData = () => {
  const [item, images, categoryName, BrandName, similarProducts, rateValue] = UseViewProductDetails();
  const [colorIndex, ColorValues, HandleAddToCart] = UseAddProductToCart(item)
  const setting = {
    size: 20,
    count: 5,
    color: "#979797",
    activeColor: "#ffc107",
    value: rateValue,
    a11y: true,
    isHalf: true,
    edit: false,
    emptyIcon: <AiOutlineStar />,
    halfIcon: <BsStarHalf />,
    filledIcon: <AiFillStar />
  }

  return (
    <div className="py-3">
      <p className="mb-0 fs-14 gray-color">{BrandName} </p>
      <p className="fw-bold fs-30 mb-1">
        {item.title}
        {rateValue ? (<ReactStars {...setting} />) : null}
      </p>
      <div className="d-flex mb-2">
        {item.availableColors ? (item.availableColors.map((color, index) => {
          return (
            <div
              key={index}
              onClick={() => ColorValues(index, color)}
              className="me-2"
              style={{ backgroundColor: color, width: "30px", height: "30px", borderRadius: "50%", border: colorIndex === index ? "1px solid #000" : "none" }}
            ></div>
          );
        })
        ) : null}
      </div>
      <p className="fs-20 mb-1 word-break-all">
        {item.description}
      </p>
      <p className="fw-bold fs-20 mb-1">
        {item.price} EGP
      </p>
      <div className="btn rounded orange-bg px-5 text-white py-3 text-center mt-3" onClick={HandleAddToCart}>
        Add to cart
      </div>
    </div>
  );
}


export default ProductData;
